import { HttpHeader } from '../utils/HttpHeader';
import { HttpRequester } from '../utils/HttpRequester';
import { Urls } from "../utils/Urls";
import { TokenService } from './TokenService';
export class WebIdService{
    private static links = Urls.URLS();
    private static requester = HttpRequester.httpRequester();
    private static headers = new HttpHeader();
    public static async getWebIdActionId(accountId:number,purpose:string){
        try {
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.post(this.links.getWebidAction(accountId), this.headers,{purpose:purpose});
            return json.data;
        }
        catch (err) {
            throw err;
        }
    }
    
}